module.exports = __webpack_public_path__ + "static/media/GraduationCap.16a79a43.svg";